import { CommonModule } from '@angular/common';
import { Component, computed, ElementRef, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PortraitService } from '../../../services/portraits/portrait.service';
import { MessengerService } from '../../../services/messenger/messenger.service';
import { ChatService } from '../../../services/chat/chat.service';
import { IdentityService } from '../../../services/identity/identity.service';

@Component({
  selector: 'app-avatar-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './avatar-modal.html',
  styleUrl: './avatar-modal.scss'
})
export class AvatarModal implements OnInit {
  private portraitService = inject(PortraitService);
  private messengerService = inject(MessengerService);
  private chatService = inject(ChatService);
  private identityService = inject(IdentityService);
  private el = inject(ElementRef);

  public portraits = this.portraitService.portraits;
  public currentUser = this.messengerService.currentUser;
  
  public selectedPortraitId = signal<number | null>(null);
  public selectedCategory = signal<string>('All');
  public newAvatarUrl = signal('');

  public categories = computed(() => {
    const cats = new Set(this.portraits().map(p => p.category));
    return ['All', ...Array.from(cats)].filter(c => !!c);
  });

  public filteredPortraits = computed(() => {
    const cat = this.selectedCategory();
    if (cat === 'All') return this.portraits();
    return this.portraits().filter(p => p.category === cat);
  });

  public isAdmin = computed(() => {
    const claims = this.identityService.getClaims();
    if (!claims) return false;
    return claims.role === 'admin' || claims['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] === 'admin';
  });

  ngOnInit() {
    const modalEl = this.el.nativeElement.querySelector('#avatarChangeModal');
    if (modalEl) {
      modalEl.addEventListener('show.bs.modal', () => {
        this.onModalOpen();
      });
    }
  }

  onModalOpen() {
    this.portraitService.getAll();
    this.selectedPortraitId.set(null);
    this.selectedCategory.set('All');
    this.newAvatarUrl.set(this.currentUser().avatar);
  }

  selectPortrait(portrait: any) {
    this.selectedPortraitId.set(portrait.id);
    const url = 'https://static.h5arena.com/images/avatars/' + portrait.fileName;
    this.newAvatarUrl.set(url);
  }

  changeAvatar() {
    const id = this.selectedPortraitId();
    if (id !== null) {
      this.portraitService.update(id).subscribe({
        next: (res: any) => {
          this.chatService.updateUser();
          if (res) {
            this.messengerService.setMe(res);
          }
        },
        error: (err) => console.error(err)
      });
    } else {
      const url = this.newAvatarUrl().trim();
      if (url) {
        // Future implementation for direct URL updates if needed
      }
    }
  }
}
